const carouselData = [
  {
    title: '暑期档观影指南',
    subtitle: '精选50部暑期必看大片',
    desc: '从热血动作到轻松喜剧，从硬核科幻到烧脑悬疑，这个夏天悟空影视陪你度过每一个精彩夜晚。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20atmosphere%20with%20warm%20golden%20lighting%2C%20popcorn%20and%20film%20reels%20on%20dark%20wood%20table%2C%20cinema%20screen%20glow%20in%20background%2C%20cozy%20ambient%20lighting%2C%20professional%20product%20photography%2C%20rich%20amber%20tones%2C%20movie%20theater%20vibe%2C%20elegant%20composition&width=1000&height=560&seq=wukong-carousel-01&orientation=landscape'
  },
  {
    title: '动作片经典回顾',
    subtitle: '重温那些燃爆的经典瞬间',
    desc: '甄选二十年动作片经典，从港式功夫到好莱坞特技，每一帧都是肾上腺素飙升的回忆杀。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20action%20movie%20montage%20aesthetic%2C%20vintage%20film%20posters%20on%20brick%20wall%2C%20warm%20tungsten%20lighting%2C%20retro%20cinema%20decor%2C%20leather%20director%20chair%2C%20film%20clapper%20board%2C%20nostalgic%20atmosphere%2C%20rich%20golden%20and%20amber%20tones%2C%20professional%20photography&width=1000&height=560&seq=wukong-carousel-02&orientation=landscape'
  },
  {
    title: '悬疑烧脑专场',
    subtitle: '考验智力的高能悬疑片',
    desc: '精选国内外高分悬疑佳作，层层反转的剧情让你欲罢不能，每一部都值得反复品味。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20warm%20desk%20lamp%20lighting%2C%20case%20files%20and%20photographs%20spread%20on%20dark%20wood%20desk%2C%20magnifying%20glass%20and%20vintage%20accessories%2C%20film%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20rich%20amber%20and%20sepia%20tones%2C%20cinematic%20composition&width=1000&height=560&seq=wukong-carousel-03&orientation=landscape'
  },
  {
    title: '国产佳片推荐',
    subtitle: '不可错过的华语好电影',
    desc: '聚焦近年来口碑爆棚的国产佳作，从文艺剧情到商业大片，展现华语电影的魅力与深度。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cinema%20poster%20display%20with%20warm%20red%20and%20gold%20accents%2C%20traditional%20lanterns%20and%20modern%20design%20elements%2C%20soft%20dramatic%20lighting%2C%20cultural%20and%20artistic%20atmosphere%2C%20professional%20photography%2C%20rich%20contrast%2C%20cinematic%20mood%2C%20minimalist%20composition&width=1000&height=560&seq=wukong-carousel-04&orientation=landscape'
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-focus-2-line text-2xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            焦点专题
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视精心策划的主题观影合集
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-[200px] md:w-[240px] h-[180px] sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <span className="text-[10px] font-semibold text-accent-400 uppercase tracking-wider mb-1">
                  {item.subtitle}
                </span>
                <h3 className="text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}